<template>
    <div :class="classes">
        <form>
            <div class="form-section">
                <div class="form-group w-80">
                    <label>SEARCH ADDRESS</label>
                    <input id="google_maps_search" ref="maps_search" type="text" placeholder="Start typing your address here"
                        class="placeholder-no-fix" aria-describedby="inputGroupPrepend" value="">
                        <!-- <div class="form-inline">Edit this field if your Store Address has changed</div> -->
                        <FormError :validationStatus="v$.address1"/>
                </div>
                <div class="w-flex-80">
                    <div class="form-group auto-filled-form">
                        <div class="input-group-cover">
                            <label>ADDRESS</label>
                            <div class="input-group-cover">
                                <input readonly type="text" id="address" placeholder="Address 1" name="address" 
                                class="placeholder-no-fix non-editable" aria-describedby="inputGroupPrepend"
                                    v-model="address1">
                            </div>
                        </div>
                    </div>
                    <div class="form-group auto-filled-form" style="margin-left: 2%">
                        <div class="input-group-cover">
                            <label>SUBURB/CITY</label>
                            <div class="input-group-cover">
                                <input readonly type="text" placeholder="Suburb/City" id="suburb" name="suburb" 
                                class="placeholder-no-fix non-editable" aria-describedby="inputGroupPrepend" v-model="suburb">
                            </div>
                        </div>
                    </div>
                </div>
                
                <div class="w-flex-80">
                    <div class="form-group auto-filled-form">
                        <div class="input-group-cover">
                            <label>POST/ZIP CODE</label>
                            <div class="input-group-cover">
                                <input readonly type="text" id="zip" placeholder="Post code" name="zip" 
                                class="placeholder-no-fix non-editable" aria-describedby="inputGroupPrepend"
                                    v-model="zip">
                            </div>
                        </div>
                    </div>
                    <div class="form-group auto-filled-form" style="margin-left: 2%">
                        <div class="input-group-cover">
                            <label>STATE/PROVINCE</label>
                            <div class="input-group-cover">
                                <input readonly type="text" placeholder="State" id="state" name="state" 
                                class="placeholder-no-fix non-editable" aria-describedby="inputGroupPrepend" v-model="state">
                            </div>
                        </div>
                    </div>
                </div>
                <div class="w-80" style="margin-top: 0px;">
                    <div class="form-group auto-filled-form">
                        <div class="input-group-cover">
                            <label>COUNTRY</label>
                            <div class="input-group-cover">
                                <input readonly id="country_id" name="country" type="text" placeholder="Country" 
                                class="placeholder-no-fix non-editable" aria-describedby="inputGroupPrepend" v-model="country">
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </form>
    </div>
</template>
<script>
import { required } from '@vuelidate/validators';
import useVuelidate from '@vuelidate/core';
import FormError from './FormError.vue';
export default {
        setup(){
            return { v$: useVuelidate() }
        },
        props: ['addressType', 'classes', 'formData', 'countryCode'],
        emits: ["update"],
        components: {FormError},
        data(){
            return {
                country: this.formData.country,
                address1: this.formData.address1,
                zip: this.formData.zip,
                suburb: this.formData.suburb,
                state: this.formData.state
            }
        },
        methods:{
            submit(){
                if(this.addressType != 'Billing'){
                    var dataObj = {
                        country: this.country,
                        address1: this.address1,
                        zip: this.zip,
                        suburb: this.suburb,
                        state: this.state,
                        billingCountry: this.country,
                        billingAddress1: this.address1,
                        billingZip: this.zip,
                        billingSuburb: this.suburb,
                        billingState: this.state
                    }
                }else{
                    var dataObj = {
                        country: this.country,
                        address1: this.address1,
                        zip: this.zip,
                        suburb: this.suburb,
                        state: this.state
                    }
                }
                this.$emit('update', {
                    data: dataObj,
                    valid: !this.v$.$invalid
                });
            }
        },
        mounted() {
                const autocomplete = new google.maps.places.Autocomplete(this.$refs['maps_search']);
                autocomplete.setComponentRestrictions({'country': this.formData.countryCode});
                autocomplete.addListener("place_changed", () => {
                    const place = autocomplete.getPlace();

                    for (let i = 0; i < place.address_components.length; i++) {
                        const component = place.address_components[i];

                        if (component.types.includes('country')) {
                            this.country = component.long_name;
                        } else if (component.types.includes('postal_code')) {
                            this.zip = component.long_name;
                        } else if (component.types.includes('postal_town') || component.types.includes('locality') || component.types.includes('sublocality') || component.types.includes('administrative_area_level_4')) {
                            this.suburb = component.long_name;
                        } else if (component.types.includes('administrative_area_level_1')) {
                            this.state = component.long_name;
                        } else if (component.types.includes('street_number')) {
                            this.address1 = component.long_name;
                        } else if (component.types.includes('route')) {
                            this.address1 += ' ' + component.long_name;
                        }
                    }

                    this.submit();
                })
        },
        validations:{
            country: {required},
            address1: {required},
            zip: {required},
            suburb: {required},
            state: {required},
        }  
}
</script>